window.MotoPromoPrices = window.MotoPromoPrices || {
  render(model, catalog) {
    const unitPrice = catalog.pairPrice / catalog.requiredItems;
    const money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: catalog.currency || 'MXN', minimumFractionDigits: 2 });
    const format = cents => money.format(cents / 100);
    const block = document.createElement('div');
    block.className = 'moto-promo-prices';
    block.dataset.promoUnitPrice = unitPrice;
    const original = Number.isInteger(model.originalPrice) && model.originalPrice > unitPrice ? model.originalPrice : null;
    if (original !== null) {
      const comparison = document.createElement('div');
      comparison.className = 'moto-promo-prices__regular';
      const label = document.createElement('span');
      label.textContent = model.originalPriceSize ? `Original, talla ${model.originalPriceSize} ` : model.originalPriceVaries ? 'Original desde ' : 'Original ';
      const crossed = document.createElement('del');
      crossed.textContent = format(original);
      crossed.dataset.regularPrice = original;
      comparison.append(label, crossed);
      block.append(comparison);
    }
    const price = document.createElement('strong');
    price.className = 'moto-promo-prices__offer';
    price.textContent = format(unitPrice);
    const condition = document.createElement('span');
    condition.className = 'moto-promo-prices__condition';
    condition.textContent = 'por casco al comprar 2';
    block.append(price, condition);
    if (original !== null) {
      const savings = document.createElement('span');
      savings.className = 'moto-promo-prices__saving';
      const savingsLabel = model.originalPriceSize ? `Ahorra en talla ${model.originalPriceSize}` : model.originalPriceVaries ? 'Ahorra desde' : 'Ahorra';
      savings.textContent = `${savingsLabel} ${format(original - unitPrice)} por casco`;
      savings.dataset.savings = original - unitPrice;
      block.append(savings);
    }
    return block;
  }
};
